import { render } from "./NoticeDetail.vue?vue&type=template&id=4c37bd3f&scoped=true"
import script from "./NoticeDetail.vue?vue&type=script&lang=js"
export * from "./NoticeDetail.vue?vue&type=script&lang=js"

import "./NoticeDetail.vue?vue&type=style&index=0&id=4c37bd3f&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4c37bd3f"

export default script